const WhereDoYouFeelMostAtHome = Object.freeze({
  OUT_IN_NATURE: 'out_in_nature',
  BY_THE_SEA: 'by_the_sea',
  BUZZING_CITY: 'buzzing_city',
  QUIET_TOWNS_AND_VILLAGES: 'quiet_towns_and_villages',
} as const);

export type WhereDoYouFeelMostAtHome =
  (typeof WhereDoYouFeelMostAtHome)[keyof typeof WhereDoYouFeelMostAtHome];

export const allWhereDoYouFeelMostAtHome: [
  WhereDoYouFeelMostAtHome,
  ...WhereDoYouFeelMostAtHome[],
] = Object.values(WhereDoYouFeelMostAtHome) as [
  WhereDoYouFeelMostAtHome,
  ...WhereDoYouFeelMostAtHome[],
];

export default WhereDoYouFeelMostAtHome;
